import { useIntl } from "react-intl";

import { Ai } from "@/patterns/ai-section/src";

import { getAiImage, getAiVideo } from "./components/assets/localized-images";

export const AiSection = () => {
    const intl = useIntl();
    const title = intl.formatMessage({
        id: "jira-product-tour.ai-section.title-text",
        defaultMessage: "Your next move, suggested by AI"
    });
    const subTitle = intl.formatMessage({
        id: "jira-product-tour.ai-section.subtitle-text",
        defaultMessage:
            "Atlassian Intelligence takes your big ideas and automatically suggests the tasks to help get it done."
    });
    const buttonText = intl.formatMessage({
        id: "jira-product-tour.ai-section.button-text",
        defaultMessage: "Explore Atlassian Intelligence"
    });
    const videoLink = getAiVideo(intl.locale);
    const imageLink = getAiImage(intl.locale);
    const videoAltText = intl.formatMessage({
        id: "jira-product-tour.ai-section.video-alt-text",
        defaultMessage: "demo of jira ai integration"
    });

    return (
        <Ai
            title={title}
            subTitle={subTitle}
            buttonText={buttonText}
            videoLink={videoLink}
            analyticsEventLabel="atlas-55799-ai-button-clicked"
            videoAltText={videoAltText}
            imageLink={imageLink}
        />
    );
};
AiSection.displayName = "AiSection";
